import { Close as CloseIcon } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { Box, Tooltip } from "@mui/material";
import React from "react";
import floatingMenuStyles from "./FloatingMenu.styles";

interface MenuClasses {
  openFirstBtn: Record<string, unknown>;
  openSecondBtn: Record<string, unknown>;
  openThirdBtn: Record<string, unknown>;
  openFourthBtn: Record<string, unknown>;
  openFifthBtn: Record<string, unknown>;
}

export interface MenuConfig {
  round: {
    icon: any;
    label: string;
    openClass: keyof MenuClasses;
    handleClick: Function;
  }[];
  line: {
    icon: any;
    label: string;
    handleClick: Function;
  }[];
}

interface CustomProps {
  menuConfigs: MenuConfig;
  position?: "top" | "bottom";
  isOpen: boolean;
  onToggle: (value: boolean) => void;
  otherMenuOpen?: boolean;
  menuIcon?: React.ReactNode; // Add this new prop
}

const FloatingMenu = (props: CustomProps) => {
  const {
    position = "top",
    isOpen,
    onToggle,
    otherMenuOpen = false,
    menuIcon,
  } = props;
  const classes = floatingMenuStyles;

  const containerStyle = {
    ...classes.container,
    top: position === "top" ? "270px" : "420px",
    ...(otherMenuOpen && classes.containerInactive),
  };

  const renderTooltipButton = (
    Item: any,
    label: string,
    handleClick: Function,
    extraStyles = {}
  ) => (
    <Tooltip
      title={label}
      placement="left"
      componentsProps={{
        tooltip: {
          sx: classes.tooltip,
        },
      }}
    >
      <Box
        sx={extraStyles}
        onClick={() => {
          handleClick();
          onToggle(false);
        }}
      >
        {React.isValidElement(Item) ? (
          Item
        ) : typeof Item === "string" ? (
          <img
            src={Item}
            alt={label}
            style={{ width: "25px", height: "25px" }}
          />
        ) : (
          <Item sx={{ color: "#fff", fontSize: "25px" }} />
        )}
      </Box>
    </Tooltip>
  );

  return (
    <>
      <Box
        sx={{
          ...classes.backdrop,
          ...(isOpen && classes.backdropOpen),
        }}
        onClick={() => onToggle(false)}
      />
      <Box sx={containerStyle}>
        <Box
          sx={{
            ...classes.menuToggle,
            ...(isOpen && classes.menuToggleActive),
            ...(otherMenuOpen && classes.menuToggleInactive),
          }}
          onClick={() => !otherMenuOpen && onToggle(!isOpen)}
        >
          <Box
            component="span"
            sx={{
              display: "flex",
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            {isOpen ? (
              <CloseIcon htmlColor="#ffffff" sx={{ fontSize: "25px" }} />
            ) : (
              menuIcon || (
                <MenuIcon htmlColor="#ffffff" sx={{ fontSize: "25px" }} />
              )
            )}
          </Box>
        </Box>

        <Box sx={classes.menuRound}>
          {props.menuConfigs.round.map(
            ({ icon, label, handleClick, openClass }, index) =>
              renderTooltipButton(icon, label, handleClick, {
                ...classes.btnApp,
                ...(isOpen && classes[openClass as keyof MenuClasses]),
              })
          )}
        </Box>

        <Box sx={classes.menuLine}>
          {props.menuConfigs.line.map(({ icon, label, handleClick }, index) =>
            renderTooltipButton(icon, label, handleClick, {
              ...classes.verticalBtn,
              top: isOpen ? `${(index + 1) * 4.25}em` : 0,
              transitionDelay: `${0.1 * (index + 1)}s`,
              opacity: isOpen ? 1 : 0,
            })
          )}
        </Box>
      </Box>
    </>
  );
};

export default FloatingMenu;
